import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import LocationOn from '@material-ui/icons/LocationOn';
import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../../intl/messages';
import { connect } from 'react-redux';
import { AppState } from '../../store/model';
import { isSaviSelectIntl } from '../../store/reducers/itinerary/selectors';

interface OwnProps {
  /**
   * Distance from location (in KM)
   */
  distanceInKm: number;

  /**
   * Name of nearby/'from' location
   */
  location: string;
}

interface StateProps {
  isSaviSelectIntl: boolean;
}

interface DistanceProps
  extends OwnProps,
    WithStyles<typeof styles>,
    InjectedIntlProps,
    StateProps {}

const DistanceBase: FunctionComponent<DistanceProps> = ({
  classes,
  distanceInKm,
  intl: { formatMessage },
  location,
  isSaviSelectIntl
}) => (
  <Typography variant="body1" color="textSecondary" lineClamp>
    <LocationOn className={classes.locationIcon} />
    {!isSaviSelectIntl ?
    formatMessage(messages.hotel.distanceInKm, {
      distanceInKm,
      location,
    }) :
    formatMessage(messages.hotel.distanceInKmForSaviSelectIntl, {
      distanceInKm,
    })}
  </Typography>
);

// styled
const styles = ({ spacing: { unit: spacing } }: Theme) =>
  createStyles({
    locationIcon: {
      height: spacing * 2,
      verticalAlign: 'text-bottom',
      width: spacing * 2,
    },
  });

const mapStateToProps = (state: AppState) => {
  return {
    isSaviSelectIntl: isSaviSelectIntl(state),
  };
};

const enhance = compose<DistanceProps, OwnProps>(
  pure,
  injectIntl,
  connect(mapStateToProps),
  withStyles(styles),
);

export const Distance = enhance(DistanceBase);

Distance.displayName = 'Distance';
